import MarketingOptions from '../../../../../../../../../common/components/MarketingOptions/MarketingOptions';
import { Field } from 'redux-form';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Marketing = () => {
  return (
    <>
      <Row>
        <Col sm={12}>
          <h3>Marketing Consent</h3>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          We American International Group UK Limited would like to send you marketing
          information about other AIG Products that we think would be of interest to you.
          If you would like to receive this information, please tick the boxes below to
          let us know how you would like to be contacted:
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Field
            name={'data.attributes.metadata.adults.0.marketing_options'}
            component={MarketingOptions}
            options={[
              { name: 'email', label: 'Email', value: 1, valid: [1, 2] },
              { name: 'sms', label: 'SMS/Text', value: 1, valid: [1, 2] },
              { name: 'phone', label: 'Telephone', value: 1, valid: [1, 2] },
              { name: 'post', label: 'Post', value: 1, valid: [1, 2] },
            ]}
            inline
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          This consent will replace any previous consents provided. You can change your
          mind and opt-out of receiving this information at any time.
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          Even if you have selected not to receive marketing information, please note that
          we may still send you non-marketing communications rom time to time concerning
          the products or services you receive from us.
        </Col>
      </Row>
    </>
  );
};

export default Marketing;
